module.exports = __webpack_public_path__ + "img/tddg-5.dc89b342.webp";